import { CVEditingSection, FullCV } from '@cibli/shared';
import React from 'react';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface LanguagesProps {
  languages: FullCV['languages'];
  onEdit?: (section: CVEditingSection) => void;
  headingColor?: string;
}

const Languages: React.FC<LanguagesProps> = ({ languages, onEdit, headingColor }) => {
  const { t } = useCVTranslation();

  const handleEdit = () => {
    if (onEdit) {
      onEdit('languages');
    }
  };

  const editable = onEdit !== undefined;
  if (!languages?.length && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable}>
      <div className="mb-2 p-2 m-2">
        <h2
          className="text-[11px] font-black uppercase tracking-widest pb-1.5 mb-2.5"
          style={{ color: headingColor ?? '#000000' }}
        >
          {t('CV.languages')}
        </h2>
        <div>
          {(languages ?? []).map((lang, index) => (
            <div
              key={index}
              className="text-[11px] font-semibold text-black mb-1.5 uppercase tracking-wide leading-relaxed"
            >
              {(lang.language ?? '').toUpperCase()}
              {lang.level && <span className="font-normal opacity-80 ml-1.5">— {lang.level}</span>}
            </div>
          ))}
        </div>
      </div>
    </EditableSection>
  );
};

export default Languages;
